import Vue from 'vue'
import Router from 'vue-router'

//apps
import Dashboard from '../views/apps/Dashboard.vue'
import Calendar from '../views/apps/Calendar.vue'
import Contacts from '../views/apps/Contacts.vue'
import Gallery from '../views/apps/Gallery.vue'
import Timeline from '../views/apps/Timeline.vue'

//pages
import Login from '../views/pages/authentication/Login.vue'
import Register from '../views/pages/authentication/Register.vue'
import ForgotPassword from '../views/pages/authentication/ForgotPassword.vue'
import Profile from '../views/pages/Profile.vue'
import NotFound from '../views/pages/NotFound.vue'
import Invoice from '../views/pages/Invoice.vue'

//ui
import Themes from '../views/ui/Themes.vue'
import Icons from '../views/ui/Icons/Icons.vue'
import MdIcons from '../views/ui/Icons/MdIcons.vue'
import FlagIcons from '../views/ui/Icons/FlagIcons.vue'
import MultiLanguage from '../views/ui/MultiLanguage.vue'
import HelperClasses from '../views/ui/HelperClasses.vue'
import Typography from '../views/ui/Typography.vue'
import layout from './layout'
import editors from './editors'
import charts from './charts'
import maps from './maps'
import tables from './tables'
import element from './element'

import layouts from '../layout'
import store from '../store'
import {hasRolePermission} from "../permission";

// ifind Cheaters Pages
import googlePage from '../views/if_pages/GoogleAnalitycs'
import UsersPage from '../views/if_pages/users/UsersPage/UsersPage'
import UserEdite from '../views/if_pages/users/UserEdite'
import NetworksPage from '../views/if_pages/networks/NetworksPage'
import NetworksEdit from '../views/if_pages/networks/NetworksEdit'
import ScansPage from "../views/if_pages/networks/ScansPage";
import ScansView from "../views/if_pages/networks/ScanView";
import TinderAccountsPage from '../views/if_pages/TinderAccountsPage'
import TinderAccountsEdit from '../views/if_pages/TinderAccountsEdit'
import ManualTinderScansPage from '../views/if_pages/ManualTinderScansPage'
import ManualTinderScanCreate from '../views/if_pages/ManualTinderScanCreate'
import PaymentPage from '@/views/if_pages/analytic/payment/PaymentPage'
import CustomersPage from '@/views/if_pages/analytic/customers/CustomersPage'
import IndexingPages from '@/views/if_pages/analytic/indexing/IndexingPages'
import ProxyTable from '@/views/if_pages/analytic/proxy/ProxyTable'
import ProxyTableEdit from '@/views/if_pages/analytic/proxy/ProxyTableEdit'
import PhoneTable from '@/views/if_pages/analytic/phone/PhoneTable'
import PhoneTableEdit from '@/views/if_pages/analytic/phone/PhoneTableEdit'
import DiscountCouponsPage from '@/views/if_pages/discount-coupons/DiscountCouponsPage'
import Monitor from '@/views/if_pages/system/Monitor'
import PostsPage from "../views/if_pages/blog/posts/PostsPage.vue";
import PostEdit from "../views/if_pages/blog/posts/PostEdit.vue";
import CategoryPage from "../views/if_pages/blog/categories/CategoryPage.vue";
import TagsPage from "../views/if_pages/blog/tags/TagsPage.vue";
import CategoryEdit from '../views/if_pages/blog/categories/CategoryEdit.vue';
import TagEdit from '../views/if_pages/blog/tags/TagEdit.vue';
import AuthorsPage  from "../views/if_pages/blog/authors/AuthorsPage.vue";
import AuthorEdit from "../views/if_pages/blog/authors/AuthorEdit.vue";
import MediaPage from "../views/if_pages/blog/media/MediaPage.vue";
import MediaEdit from "../views/if_pages/blog/media/MediaEdit.vue";
import MediaCreate from "../views/if_pages/blog/media/MediaCreate.vue";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            alias: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: '/users',
            name: 'users',
            component: UsersPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Users List',
                tags: ['app']
            }
        },
        {
            path: '/users/:id/edit',
            name: 'user-edit',
            component: UserEdite,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'User Edit',
                tags: ['app']
            }
        },
        {
            path: '/users/create',
            name: 'user-create',
            component: UserEdite,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'User Create',
                tags: ['app']
            }
        },
        {
            path: '/networks',
            name: 'networks',
            component: NetworksPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Networks',
                tags: ['app']
            }
        },
        {
            path: '/networks/:id/edit',
            name: 'network-edit',
            component: NetworksEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Network Edit',
                tags: ['app']
            }
        },
        {
            path: '/networks/create',
            name: 'network-create',
            component: NetworksEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Network Create',
                tags: ['app']
            }
        },
        {
            path: '/scans',
            name: 'scans',
            component: ScansPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Scans',
                tags: ['app']
            }
        },
        {
            path: '/scans/:id/view',
            name: 'scan-view',
            component: ScansView,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Scan View',
                tags: ['app']
            }
        },
        {
            path: '/tinder-accounts',
            name: 'tinder-accounts',
            component: TinderAccountsPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['manager']) ? TinderAccountsPage.beforeRouteEnter(to, from, next) : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Tinder Accounts',
                tags: ['app']
            },
        },
        {
            path: '/tinder-accounts/:id/edit',
            name: 'tinder-account-edit',
            component: TinderAccountsEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['manager']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Tinder Account Edit',
                tags: ['app']
            }
        },
        {
            path: '/tinder-accounts/create',
            name: 'tinder-account-create',
            component: TinderAccountsEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Tinder Account Edit',
                tags: ['app']
            }
        },
        {
            path: '/manual-tinder-scans',
            name: 'manual-tinder-scans',
            component: ManualTinderScansPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['manager']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Manual Tinder Scans',
                tags: ['app']
            }
        },
        {
            path: '/manual-tinder-scans/create',
            name: 'manual-tinder-scan-create',
            component: ManualTinderScanCreate,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['manager']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Create Manual Tinder Scan',
                tags: ['app']
            }
        },
        {
            path: '/ga',
            name: 'google-analytics',
            component: googlePage,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: '/discount-coupons',
            name: 'discount-coupons',
            component: DiscountCouponsPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo', 'manager']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: '/contacts',
            name: 'contacts',
            component: Contacts,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['users', 'address', 'book', 'app']
            }
        },
        {
            path: '/gallery',
            name: 'gallery',
            component: Gallery,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['photo', 'app']
            }
        },
        {
            path: '/timeline',
            name: 'timeline',
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            component: Timeline,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: '/themes',
            name: 'themes',
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            component: Themes,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['ui']
            }
        },
        {
            path: '/icons',
            name: 'icons',
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            component: Icons,
            meta: {
                auth: true,
                layout: layouts.navLeft
            },
            children: [{
                    path: 'md-icons',
                    name: 'md-icons',
                    component: MdIcons,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        title: 'Material Design Icons',
                        tags: ['material design']
                    }
                },
                {
                    path: 'flag-icons',
                    name: 'flag-icons',
                    component: FlagIcons,
                    meta: {
                        auth: true,
                        layout: layouts.navLeft,
                        searchable: true,
                        title: 'Flag Icons',
                        tags: ['list', 'ui']
                    }
                }
            ]
        },
        {
            path: '/multi-language',
            name: 'multi-language',
            component: MultiLanguage,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['ui', 'translate']
            }
        },
        {
            path: '/helper-classes',
            name: 'helper-classes',
            component: HelperClasses,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Helper Classes',
                tags: ['ui']
            }
        },
        {
            path: '/typography',
            name: 'typography',
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            component: Typography,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Typography',
                tags: ['ui']
            }
        },
        layout,
        editors,
        charts,
        maps,
        tables,
        element,
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['pages']
            }
        },
        {
            path: '/invoice',
            name: 'invoice',
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            component: Invoice,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['pages']
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                layout: layouts.contenOnly
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: {
                layout: layouts.contenOnly
            }
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: ForgotPassword,
            meta: {
                layout: layouts.contenOnly
            }
        },
        {
            path: '/logout',
            beforeEnter(to, from, next) {
                auth.logout()
                next({ path: '/login' })
            }
        },
        {
            path: '/posts',
            name: 'posts',
            component: PostsPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Posts',
                tags: ['app']
            }
        },
        {
            path: '/posts/:id/edit',
            name: 'post-edit',
            component: PostEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Post Edit',
                tags: ['app']
            }
        },
        {
            path: '/posts/create',
            name: 'post-create',
            component: PostEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Post Edit',
                tags: ['app']
            }
        },
        {
            path: '/category',
            name: 'category',
            component: CategoryPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Category',
                tags: ['app']
            }
        },
        {
            path: '/category/:id/edit',
            name: 'category-edit',
            component: CategoryEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Category Edit',
                tags: ['app']
            }
        },
        {
            path: '/category/create',
            name: 'category-create',
            component: CategoryEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Category Create',
                tags: ['app']
            }
        },
        {
            path: '/tags',
            name: 'tags',
            component: TagsPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'tags',
                tags: ['app']
            }
        },
        {
            path: '/tag/:id/edit',
            name: 'tag-edit',
            component: TagEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Tag Edit',
                tags: ['app']
            }
        },
        {
            path: '/tag/create',
            name: 'tag-create',
            component: TagEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Tag Create',
                tags: ['app']
            }
        },
        {
            path: '/authors',
            name: 'authors',
            component: AuthorsPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'authors',
                tags: ['app']
            }
        },
        {
            path: '/author/:id/edit',
            name: 'author-edit',
            component: AuthorEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Author Edit',
                tags: ['app']
            }
        },
        {
            path: '/author/create',
            name: 'author-create',
            component: AuthorEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Author Create',
                tags: ['app']
            }
        },
        {
            path: '/media',
            name: 'media',
            component: MediaPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'meida',
                tags: ['app']
            }
        },
        {
            path: '/media/:id/edit',
            name: 'media-edit',
            component: MediaEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Media Edit',
                tags: ['app']
            }
        },
        {
            path: '/media/create',
            name: 'media-create',
            component: MediaCreate,
            beforeEnter: (to, from, next) => {
                hasRolePermission(['seo']) ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                title: 'Media Create',
                tags: ['app']
            }
        },
        {
            path: '/analytic/payment',
            name: 'analytic-payment',
            component: PaymentPage,
            beforeEnter: (to, from, next) => {
              if(hasRolePermission()) {
                next();
              } else{
                next('/dashboard');
              }
            },
            meta: {
                layout: layouts.navLeft
            }
        },
        {
            path: '/analytic/customers',
            name: 'analytic-customers',
            component: CustomersPage,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                layout: layouts.navLeft
            }
        },
        {
            path: '/analytic/indexing',
            name: 'analytic-indexing',
            component: IndexingPages,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                layout: layouts.navLeft
            }
        },
        {
            path: '/analytic/proxy',
            name: 'proxy-table',
            component: ProxyTable,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                layout: layouts.navLeft
            }
        },
        {
            path: '/analytic/proxy/edit/:id',
            name: 'proxy-edit',
            component: ProxyTableEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Proxy Table Edit',
                tags: ['app']
            }
        },
        {
            path: '/analytic/proxy/create',
            name: 'proxy-create',
            component: ProxyTableEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Proxy Table Edit',
                tags: ['app']
            }
        },
        {
            path: '/analytic/phone',
            name: 'phone-table',
            component: PhoneTable,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                layout: layouts.navLeft
            }
        },
        {
            path: '/analytic/phone/edit',
            name: 'phone-edit',
            component: PhoneTableEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Phone Table Edit',
                tags: ['app']
            }
        },
        {
            path: '/analytic/phone/create',
            name: 'phone-create',
            component: PhoneTableEdit,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Phone Table Edit',
                tags: ['app']
            }
        },
        {
            path: '/system/monitor',
            name: 'system-monitor',
            component: Monitor,
            beforeEnter: (to, from, next) => {
                hasRolePermission() ? next() : next('/dashboard')
            },
            meta: {
                auth: true,
                layout: layouts.navLeft,
                title: 'Queue Monitor',
                tags: ['app']
            }
        },
        {
            path: '*',
            name: 'not-found',
            component: NotFound,
            meta: {
                layout: layouts.contenOnly
            }
        }
    ]
})


export const l = {
    contenOnly() {
        store.commit('setLayout', layouts.contenOnly)
    },
    navLeft() {
        store.commit('setLayout', layouts.navLeft)
    },
    navRight() {
        store.commit('setLayout', layouts.navRight)
    },
    navTop() {
        store.commit('setLayout', layouts.navTop)
    },
    navBottom() {
        store.commit('setLayout', layouts.navBottom)
    },
    set(layout) {
        store.commit('setLayout', layout)
    }
}

//insert here login logic
const auth = {
    loggedIn() {
        return store.getters.isLogged
    },
    logout() {
        store.commit('setLogout')
    }
}

/*router.beforeEach((to, from, next) => {
	let authrequired = false
	if(to && to.meta && to.meta.auth)
		authrequired = true

	//console.log('authrequired', authrequired, to.name)

	if(authrequired) {
		if(auth.loggedIn()) {
			if(to.name === 'login') {
				window.location.href = '/'
				return false
			} else {
				next()
			}
		} else {
			if(to.name !== 'login'){
				window.location.href = '/login'
				return false
			}
			next()
		}
	} else {
		if(auth.loggedIn() && to.name === 'login'){
			window.location.href = '/'
			return false
		} else {
			next()
		}
	}

	if(to && to.meta && to.meta.layout){
		l.set(to.meta.layout)
	}
})

router.afterEach((to, from) => {
	setTimeout(()=>{
		store.commit('setSplashScreen', false)
	}, 500)
})*/

export default router